import {Controller} from "@hotwired/stimulus";
import JustValidate from "just-validate";

export default class extends Controller {
    connect() {
        // Let JustValidate control errors; avoid native blocking
        this.element.setAttribute("novalidate", "novalidate")
        this.validator = new JustValidate(this.element, {
            validateBeforeSubmitting: false,
        });

        this.validator
            .addField('#full_name', [
                {rule: 'required', errorMessage: 'Full name is required'},
                {rule: 'minLength', value: 2, errorMessage: 'Please enter at least 2 characters'},
            ])
            .addField('#email', [
                {rule: 'required', errorMessage: 'Email is required'},
                {rule: 'email', errorMessage: 'Please enter a valid email'},
            ])
        this.element.removeEventListener("submit", this.validator.submitHandler);
    }

    async onSubmit(event) {
        if (this.runningValue) return;

        event.preventDefault();

        const valid = await this.validator.revalidate().catch(() => false);
        if (!valid) return;

        this.runningValue = true;

        document.addEventListener("turbo:submit-start", (e) => {
            console.log("Turbo submit started", e.detail);
        });

        // Click the hidden submit button to trigger a native submit
        setTimeout(() => {
            const hiddenSubmit = this.element.querySelector('#hidden_submit_button');
            if (hiddenSubmit) {
                hiddenSubmit.click();
            } else {
                this.element.submit(); // Fallback
            }
        }, 0);
    }

}